// Author thq
// Date 2021-04-15 17:25:44

class EmSppStorageCatSsc {
constructor({
        id = null,
        name = '',
        parentId = '',
        level = '',
        nodeCode = '',
        seq = '',
        sscRemark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.parentId = parentId;
    this.level = level;
    this.nodeCode = nodeCode;
    this.seq = seq;
    this.sscRemark = sscRemark;
}
}

function newEntity() {
return new EmSppStorageCatSsc();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.spareparts.emSppStorageCatSsc.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.spareparts.emSppStorageCatSsc.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentId',
        label: 'label.em.spareparts.emSppStorageCatSsc.grid.parentId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.em.spareparts.emSppStorageCatSsc.grid.level',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.em.spareparts.emSppStorageCatSsc.grid.nodeCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.em.spareparts.emSppStorageCatSsc.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sscRemark',
        label: 'label.em.spareparts.emSppStorageCatSsc.grid.sscRemark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    nameFilter : "",
    parentIdFilter : "",
    levelFilter : "",
    nodeCodeFilter : "",
    seqFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.spareparts.emSppStorageCatSsc.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentIdFilter',
        label: 'label.em.spareparts.emSppStorageCatSsc.filter.parentId',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emSppStorageCatSsc'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'seqFilter',
        label: 'label.em.spareparts.emSppStorageCatSsc.filter.seq',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.spareparts.emSppStorageCatSsc.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'parentId',
        label: 'label.em.spareparts.emSppStorageCatSsc.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emSppStorageCatSsc'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'seq',
        label: 'label.em.spareparts.emSppStorageCatSsc.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'sscRemark',
        label: 'label.em.spareparts.emSppStorageCatSsc.entity.sscRemark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmSppStorageCatSsc, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
